import React from 'react';
import { CheckCircle, Award, Users, TrendingUp } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const AboutPage = () => {
  const values = [
    {
      icon: Award,
      title: 'Unser Anspruch',
      description: 'Wir setzen auf höchste Beratungsqualität. Alle unsere Berater verfügen über eine solide Fachausbildung – vom Versicherungsvermittler VBV bis hin zum Finanzplaner IAF. Damit garantieren wir Kompetenz und Professionalität auf einem Niveau, das deutlich über dem Branchenstandard liegt.'
    },
    {
      icon: Users,
      title: 'Langjährige Expertise',
      description: 'Unser Team verfügt über viele Jahre Erfahrung in Vorsorge, Finanzplanung, Risikoabsicherung und Anlageberatung. Wir kennen den Schweizer Markt und seine regulatorischen Anforderungen im Detail – und nutzen dieses Wissen für nachhaltige, massgeschneiderte Lösungen.'
    },
    {
      icon: TrendingUp,
      title: 'Innovativ & kundenfokussiert',
      description: 'Wir verbinden moderne Technologien mit persönlicher Betreuung. Für uns bedeutet Innovation nicht nur Digitalisierung, sondern die kontinuierliche Weiterentwicklung unserer Beratung – fachlich, menschlich und strategisch.'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-50/50">
      {/* Hero Section */}
      <section className="relative pt-48 pb-20 overflow-hidden">
        <div className="absolute inset-0 z-0">
          <div className="absolute top-20 right-10 w-96 h-96 bg-blue-400/20 rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 left-10 w-96 h-96 bg-blue-600/20 rounded-full blur-3xl"></div>
        </div>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-blue-900 mb-6">
              Über uns
            </h1>
            <div className="w-24 h-1 bg-gradient-to-r from-blue-600 to-blue-700 mx-auto mb-8"></div>
            <p className="text-xl md:text-2xl text-slate-700 leading-relaxed">
              Wir stehen für eine moderne, transparente und kundenorientierte Finanz- und Versicherungsberatung in der Schweiz. Als innovativer Broker verbinden wir fundierte Fachausbildung mit praxisnaher Erfahrung und begleiten unsere Kundinnen und Kunden langfristig und persönlich.
            </p>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20 relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {values.map((value, index) => {
              const Icon = value.icon;
              return (
                <Card
                  key={index}
                  className="border-blue-100 bg-white/80 backdrop-blur-sm hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
                >
                  <CardContent className="pt-8 pb-8">
                    <div className="flex flex-col items-center text-center">
                      <div className="w-16 h-16 bg-gradient-to-br from-blue-600 to-blue-700 rounded-xl flex items-center justify-center mb-6 shadow-lg">
                        <Icon className="text-white" size={32} />
                      </div>
                      <h3 className="text-2xl font-bold text-blue-900 mb-4">
                        {value.title}
                      </h3>
                      <p className="text-slate-600 leading-relaxed">
                        {value.description}
                      </p>
                    </div>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 relative">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Card className="border-blue-200 bg-gradient-to-br from-blue-600 to-blue-700 shadow-2xl">
            <CardContent className="pt-12 pb-12">
              <CheckCircle className="mx-auto mb-6 text-white" size={64} />
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
                Bereit für eine persönliche Beratung?
              </h2>
              <p className="text-xl text-blue-50 mb-8 max-w-2xl mx-auto">
                Kontaktieren Sie uns noch heute für ein unverbindliches Erstgespräch.
              </p>
              <a
                href="/#contact"
                className="inline-block bg-white text-blue-700 hover:bg-blue-50 font-semibold px-8 py-4 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
              >
                Jetzt Kontakt aufnehmen
              </a>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;